import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isChat: true,
    filters: {
        assigned_user_id: null,
        search: null,
        unread: false,
        netsuite_customer_id: null,
        not_responded: false,
        status: 1,
        type: 'PAGE',
    },
    alternateFilters: null
};

const contactsSlice = createSlice({
    name: 'contacts',
    initialState,
    reducers: {
        setFilters: (state, action) => {
            if (action.payload === null) {
                state.filters = initialState.filters;
            } else {
                state.filters = {
                    ...state.filters,
                    ...action.payload,
                };
            }
        },
        setIsChat: (state, action) => {
            state.isChat = action.payload;
        },
        setAlternateFilters: (state, action) => {
            state.alternateFilters = action.payload;
        }
    },
});

export const { setFilters, setIsChat, setAlternateFilters } = contactsSlice.actions;

export default contactsSlice.reducer;
